import { Component } from '@angular/core';
import { TemplateCardBaseComponent } from '@shared/base-components/template-card.base.component';

@Component({
  selector: 'simulation-template-card',
  templateUrl: './simulation-template-card.component.html',
  styleUrls: ['./simulation-template-card.component.scss']
})
export class SimulationTemplateCardComponent extends TemplateCardBaseComponent {}